<script setup>
</script>

<template>
  <div class="cloud-calculator__how-to-item">
    <div class="cloud-calculator__how-to-item-number"></div>
    <div class="cloud-calculator__how-to-icon">
      <slot name="icon"/>
    </div>
    <div class="cloud-calculator__how-to-content">
      <div class="cloud-calculator__how-to-name">
        <slot name="title"/>
      </div>
      <slot/>
    </div>
  </div>
</template>
